<template>
	<div class="page">
		<div class="cont">
			<div class="flex flex-b">
				<Breadcrumb :pathList='pathList'></Breadcrumb>
				<div class="search flex">
					<img src="../../assets/icon/search.png" style="width: 16px;height: 16px;" alt="" />
					<input type="text" v-model="keyword" placeholder="搜索课程" @keyup.enter="searchCourse()">
				</div>
			</div>
			<div class="navs flex">
				<div class="tit">学习状态</div>
				<div class="navItem pointer" :class="navIndex==0?'active':''" @click="changeNavIndex(0)">全部</div>
				<div class="navItem pointer" :class="navIndex==1?'active':''" @click="changeNavIndex(1)">未学习</div>
				<div class="navItem pointer" :class="navIndex==2?'active':''" @click="changeNavIndex(2)">学习中</div>
				<div class="navItem pointer" :class="navIndex==3?'active':''" @click="changeNavIndex(3)">已完成</div>
				<div class="navItem pointer" :class="navIndex==4?'active':''" @click="changeNavIndex(4)">收藏列表</div>
			</div>
			<div class="result">共找到 <span>{{courseList.length}}</span> 门课程</div>
			<div class="flex flex-wrap" style="margin-bottom: 80px;">
				<div class="itembg1 pointer" v-for="item in courseList" @click="navIndex!=4?goDetail(item):toDetail(item)">
					<div class="rel">
						<img :src="item.img" style="width: 100%;height: 228px;border-radius: 13px;" />
						<div class="status status2" v-if="item.status==1">未学习</div>
						<div class="status" v-if="item.status==2">学习中</div>
						<div class="status status3" v-if="item.status==3">已完成</div>
					</div>
					<div class="ititle">{{item.name}}</div>
					<div class="flex flex-b">
						<div class="flag flex flex-c">{{item.course_category_name?item.course_category_name:item.course_cate_name}}</div>
						<!-- <div class="flag1">加工中心学院</div> -->
					</div>
					<div class="t" v-if="navIndex!=4">已购 {{item.chapter_count}} 章</div>
					<div class="sc flex pointer" v-if="navIndex==4" @click.stop="delCollect(item.course_uuid)">
						<img src="../../assets/images/icon/isc.png"
							style="width: 16px;height: 16px;margin-right: 6px;" />
						取消收藏
					</div>
				</div>
			</div>
			<Pagination :total="count" :page_size="page_size"  @currentChange='currentChange'></Pagination>
		</div>
		<toTop></toTop>
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		getCollect,
		delCollect,
		getCourse
	} from '@/api/course';
	import {
		getMyCourse
	} from '@/api/mine';
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import Footer from '../../components/Footer.vue'
	import toTop from '../../components/toTop.vue'
	import Pagination from '../../components/Pagination.vue'
	export default {
		data() {
			return {
				pathList: [{
						title: '我的',
						path: '/mine'
					},
					{
						title: '我的课程',
						path: ''
					}
				],
				navIndex: 0,
				courseList: [],
				courseList2: [], //课程收藏列表
				keyword: '',
				page_size:12,
				page_index:1,
				count:0
			}
		},
		components: {
			Breadcrumb,
			toTop,
			Footer,
			Pagination
		},
		mounted() {
			this.getMyCourse()
		},
		methods: {
			//改变页数
			currentChange(e) {
				this.page_index = e
				this.getMyCourse()
			},
			goDetail(item){
				this.$router.push({
					path:'/myCourseDetail',
					query:{
						id:item.course_uuid,
					}
				})
			},
			toDetail(item){
				this.$router.push({
					path: '/courseDetail',
					query: {
						id: item.course_uuid,
					}
				})
			},
			searchCourse(){
			},
			changeNavIndex(e) {
				this.navIndex = e
				if (e == 4) {
					this.getCollect()
				} else{
					this.courseList = []
					this.getMyCourse()
				}
			},
			async getMyCourse() {
				const {
					status,
					data
				} = await getMyCourse({
					status: this.navIndex,
					page_index:this.page_index,
					page_size:this.page_size
				})
				this.courseList = data.result.data
				this.count = data.result.total
			},
			async getCollect() {
				const {
					status,
					data
				} = await getCollect({})
				this.courseList2 = data.result.data
				this.courseList = this.courseList2
				this.count = data.result.total
				this.collect = true
			},
			//取消收藏
			async delCollect(id) {
				const {
					status,
					data
				} = await delCollect({
					uuid: id,
				})
				this.getCollect()
			},
			toPage(path) {
				this.$router.push({
					path: path
				})
			},
		}

	}
</script>

<style lang="less" scoped>
	.cont {
		padding: 30px 133px;

		.search {
			height: 40px;
			background: #F7F8F9;
			border-radius: 13px 13px 13px 13px;
			padding: 0 20px;

			input {
				margin-left: 10px;
				border: none;
				background-color: transparent;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333;

				&:focus {
					outline: none;
				}
			}
		}

		.navs {
			margin: 30px 0 10px;

			.tit {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #666666;
				margin-right: 30px;
			}

			.navItem {
				margin-right: 20px;
				height: 36px;
				padding: 0 16px;
				background: #FFFFFF;
				border-radius: 9px 9px 9px 9px;
				border: 1px solid #EEEEEE;
				opacity: 0.8;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
				line-height: 36px;
			}

			.active {
				background: rgba(0, 167, 60, 0.06);
				border-radius: 9px 9px 9px 9px;
				opacity: 0.8;
				color: #00A73C;
			}
		}

		.result {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			color: #000000;
			line-height: 60px;

			span {
				color: #00A73C;
			}
		}

		.itembg1 {
			width: calc(25% - 15px);
			margin-right: 20px;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			background: #FFFFFF;
			border-radius: 13px 13px 13px 13px;
			padding: 9px 11px 16px 11px;
			position: relative;
			margin-bottom: 14px;

			&:nth-child(4n) {
				margin-right: 0;
			}

			.rel {
				position: relative;
				border-radius: 13px;
				overflow: hidden;

				.status {
					position: absolute;
					right: 0;
					top: 0;
					height: 22px;
					background: #00A73C;
					border-radius: 0px 13px 0px 9px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #FFFFFF;
					line-height: 22px;
					padding: 0 10px;

					&.status2 {
						background: #D7B155;
					}

					&.status3 {
						background: #FC5F5F;
					}
				}
			}

			.ititle {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 18px;
				color: #000000;
				margin-top: 13px;
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
			}

			.addItem {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
			}

			.flag {
				margin: 10px 0 6px;
				height: 22px;
				line-height: 22px;
				padding: 0 6px;
				background: rgba(0, 167, 60, 0.06);
				border-radius: 4px 4px 4px 4px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #00A73C;
			}

			.flag1 {
				margin: 10px 0 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;
			}

			.sc {
				margin-top: 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
			}

			.t {
				margin-top: 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #D7B155;
			}
		}
	}
</style>